import { Field } from "formik";
import styled from "styled-components";

import { numberInputStyles } from "../../common/NumberInput/NumberInputStyles";

const StyledField = styled(Field)`
  ${numberInputStyles};
`;

export { StyledField };
